import * as React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { setDate } from '../../actions/claimSubmitActions';
import ModernDatepicker from 'react-modern-datepicker';
import './DatePicker.css'
import { checkLegalQuestionValidation, setLegalAnswerById } from '../../actions/salesActions';

class DatePicker extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            startDate: "",
            maxDate: new Date(),
            selectedDate: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }

    async handleChange(date) {
        this.setState({
            startDate: date
        });
        if (this.props.isSales) {
            await this.props.dispatchSetLegalAnswerById(this.props.questionId, date);
            await this.props.dispatchCheckLegalQuestionValidation()
        }
        else {
            this.props.dispatchSetDate(date);
        }
    }

    render() {
        return <>{!this.props.isSales &&
            < ModernDatepicker
                date={this.props.claimSubmit.incidentDate}
                format={'DD-MM-YYYY'}
                showBorder
                onChange={(date) => this.handleChange(date)}
                placeholder='Incident date'
                className="calendar-inline-icon"
                maxDate={this.state.maxDate}
            />
        }
            {this.props.isSales &&
                <ModernDatepicker
                    date={this.props.sales.adminJudgementAnswerSet.secondaryAdminJudgementAnswers.find(x => x.secondaryQuestionId === this.props.questionId).dateAnswerStr}
                    format={'DD-MM-YYYY'}
                    showBorder
                    onChange={(date) => this.handleChange(date)}
                    placeholder='Date'
                    className="calendar-inline-icon"
                    maxDate={this.state.maxDate}
                />
            }
        </>
    }
}


const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        sales : state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(push(des)),
        dispatchSetDate: (data) => dispatch(setDate(data)),
        dispatchSetLegalAnswerById: (questionId, answerDate) => dispatch(setLegalAnswerById(questionId, answerDate, false, 0)),
        dispatchCheckLegalQuestionValidation: () => dispatch(checkLegalQuestionValidation()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DatePicker)